import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { authHandler } from '../index';
import usePoolDetails from '../state/usePoolDetails';
import PoolDetailsHeader from '../components/PoolDetailsHeader';
import PoolSummary from '../components/PoolSummary';
import AddCoupon from '../components/AddCoupon';
import FinishedPoolInfo from 'features/SpilKlub/components/FinishedPoolInfo';
import '../styles/pool-details-header.css';
import { bindActionCreators } from 'redux';
import * as UiActions from 'actions/UiActions';
import useTweaks from '../state/useTweaks';
import { getScreenUrl, GROUP_LIST_SLUG, POOL_DETAILS_SLUG } from './useScreens';
import { NotificationManager } from 'react-notifications';
import LoginWarning from '../components/LoginWarning';

const onLoginClose = () => {
    browserHistory.push(getScreenUrl(GROUP_LIST_SLUG));
    NotificationManager.error(
        'Du skal være logge ind for at se en privat SpilKlub gruppe'
    );
};

const PoolDetails = ({ entityId: poolHash, uiActions, userId }) => {
    const [queryEnabled, setQueryEnabled] = useState(true);
    const [authFailed, setAuthFailed] = useState(false);

    // in case of pool/hash request we don't know if it's public or private group
    // public groups are available for unauthorized users, private not
    //
    // so need a first try for unauthorized users, then using a state
    // to determine if react-query should be stopped
    const onPoolLoginRestriction = () => {
        setQueryEnabled(false);
        setAuthFailed(true);
        authHandler(uiActions, POOL_DETAILS_SLUG, {
            onCloseModal: onLoginClose,
            onCloseModalAutoHide: true,
        });
    };
    // restore react-query after login
    useEffect(
        () => {
            if (userId && !queryEnabled) {
                setQueryEnabled(true);
            }
            if (userId && authFailed) {
                setAuthFailed(false);
            }
        },
        [userId]
    );

    const {
        pool,
        status,
        refetch: refetchPoolDetails,
        isPoolOwner,
    } = usePoolDetails({
        enabled: queryEnabled,
        poolHash,
        authHandler: onPoolLoginRestriction,
        userId,
    });

    // set group id so the UI 'knows'
    const groupId = pool?.poolTemplate?.poolTemplateId;
    const { setUIGroupId } = useTweaks();

    useEffect(
        () => {
            if (groupId) {
                setUIGroupId(groupId);
            }
        },
        [groupId]
    );

    const finishedCoupon = !['OPEN', 'CREATED', 'PENDING'].includes(
        pool?.status
    );

    return authFailed ? (
        <div className="container-md">
            <LoginWarning />
        </div>
    ) : (
        <div className={'pool-wrapper'}>
            <PoolDetailsHeader pool={pool} status={status} />

            <PoolSummary
                pool={pool}
                status={status}
                isPoolOwner={isPoolOwner}
                refetchPoolDetails={refetchPoolDetails}
            />

            {!finishedCoupon ? (
                isPoolOwner && (
                    <AddCoupon
                        poolId={pool?.poolId}
                        refetchPoolDetails={refetchPoolDetails}
                    />
                )
            ) : (
                <FinishedPoolInfo payout={pool?.payout} />
            )}
        </div>
    );
};

function mapStateToProps(state) {
    return {
        userId: state.auth?.user?.userId || 0,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PoolDetails);
